import React from "react";
import { IconButton, Modal, Box, List, ListItem, Typography } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { CIRepMetadata } from "src/model/CIRepMetadata";
import { ERROR_MESSAGE_RETRIEVE_METADATA } from './constant';
import { useStyles } from "src/styles/CIRepMetadataModalStyles";

type CIRepMetadataModalProps = {
    metadata: CIRepMetadata | undefined,
    open: boolean,
    displayErrorMessage: boolean,
    onCloseModal: () => void
}

const CIRepMetadataModal: React.FunctionComponent<CIRepMetadataModalProps> = (props: CIRepMetadataModalProps) => {
    const styles = useStyles();

    const generateAffinityMatrixClusterCentersString = (affinityMatrixClusterCenters: number[][]) => {
        let array: string[] = [];
        affinityMatrixClusterCenters.forEach((affinity_matrix_cluster_center) => {
            array.push(`[${affinity_matrix_cluster_center.join(", ")}]`);
        })
        return array.join(", ")
    }

    const generateMetadataList = () => {
        if (props.metadata && !props.displayErrorMessage) {
            return (
                <List>
                    <ListItem>{`num_clusters: ${props.metadata.num_clusters}`}</ListItem>
                    <ListItem>{`cluster_center_indices: [${props.metadata.cluster_center_indices.join(", ")}]`}</ListItem>
                    <ListItem>{`cluster_frequencies: [${props.metadata.cluster_frequencies.join(", ")}]`}</ListItem>
                    <ListItem>{`major_cluster_indices: [${props.metadata.major_cluster_indices.join(", ")}]`}</ListItem>
                   <ListItem>{`mean_cluster_affinities: [${props.metadata.mean_cluster_affinities.join(", ")}]`}</ListItem>
                   <ListItem>{`affinity_matrix_cluster_centers: [${generateAffinityMatrixClusterCentersString(props.metadata.affinity_matrix_cluster_centers)}]`}</ListItem>
                </List> 
            )
        } else if (props.displayErrorMessage) {
            return <Typography className={styles.errorMessageText}>{ERROR_MESSAGE_RETRIEVE_METADATA}</Typography>
        }
    }; 

    return (
        <Modal    
            hideBackdrop
            open={props.open}>
            <Box className={styles.modalBox} >
                <div className={styles.modalHead}>
                    <IconButton 
                        className={styles.closeButton} 
                        onClick={() => props.onCloseModal()}>
                        <CloseIcon />
                    </IconButton>
                </div>
                <div className={styles.modalContent}>
                    {generateMetadataList()}  
                </div>   
            </Box> 
        </Modal>
    );
}

export default CIRepMetadataModal;
